import { AbstractControl, ValidationErrors } from '@angular/forms';

export class ContainsSpaceValidator {
  static containsWhiteSpace(control: AbstractControl): ValidationErrors | null {

    if (control.value && typeof control.value === 'string') {
      let value = control.value as string;
      if (value.indexOf(' ') >= 0) {
        return {containsWhiteSpace : true}
      }
    } else {
      return null;
    }
  }
}
